import script from "./makeRecharge.vue?vue&type=script&setup=true&lang=js"
export * from "./makeRecharge.vue?vue&type=script&setup=true&lang=js"

import "./makeRecharge.vue?vue&type=style&index=0&id=2b65a88a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b65a88a"]])

export default __exports__